export const TodoType = {
    EMAIL_DEFRA: 'EMAIL_DEFRA',
    EMAIL_CERS: 'EMAIL_CERS',
    EMAIL_POLICE: 'EMAIL_POLICE',
    EMAIL_FIRE_BRIGADE: 'EMAIL_FIRE_BRIGADE', 
    PAPERWORK_RECEIVED: 'PAPERWORK_RECEIVED',
    DANGEROUS_CARGO: 'DANGEROUS_CARGO',
    DIVERS_REQUIRED: 'DIVERS_REQUIRED',
};